import React from "react";
import DepartmentHome from "../components/DepartmentHome.jsx";

const items = [
  ["Clients", "/admin/clients", "Client records, care plans, documents and contacts"],
  ["Caregivers", "/admin/caregivers", "Employees list filtered to field caregivers"],
  ["Scheduling", "/admin/scheduling", "Build and manage the visit schedule"],
  ["Live Operations", "/admin/operations", "Watch today's visits and staffing in real time"],
  ["EVV Monitor", "/admin/evv", "Electronic visit verification clock-ins and exceptions"],
  ["Communications", "/admin/communications", "Review messages between staff, clients and families"],
];

const icons = {
  "Clients": "👥",
  "Caregivers": "🧑‍⚕️",
  "Scheduling": "📅",
  "Live Operations": "🟢",
  "EVV Monitor": "📍",
  "Communications": "💬",
};

export default function CareHome() {
  return (
    <DepartmentHome
      title="Care Operations"
      description="Clients, caregivers, scheduling, and live visit monitoring."
      items={items}
      icons={icons}
    />
  );
}
